import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  bulkUpsertClasses,
  BULK_UPSERT_CLASSES_SUCCESS_MESSAGE,
  classesPath,
  fetchClasses,
  FETCH_CLASSES_SUCCESS_MESSAGE,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import ClassSpreadSheet from "../../../templates/manager/ClassSpreadSheet";
import { IClassForRegister } from "../../../state";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

const BulkEditClasses = () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const [fetched, setFetched] = React.useState({
    classes: false,
  });
  const history = useHistory();
  const { currentYear } = useCurrentYear();

  React.useEffect(() => {
    if (state.success_message === BULK_UPSERT_CLASSES_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(classesPath);
    }
    if (state.success_message === FETCH_CLASSES_SUCCESS_MESSAGE) {
      setTimeout(() => {
        setFetched(s => ({ ...s, classes: true }));
      }, 100);
    }
  }, [history, dispatch, state.success_message]);

  const bulkUpsertClassesFunc = React.useCallback(
    (classes: IClassForRegister[]) => {
      dispatch(peep(bulkUpsertClasses(currentYear, classes)));
    },
    [dispatch, peep, currentYear],
  );

  React.useEffect(() => {
    dispatch(fetchClasses(currentYear));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, currentYear]);

  return (
    <div>
      <Breadcrumb
        links={[{ title: titles.classes, to: classesPath }]}
        currentTitle={titles.bulkEditClasses}
      />
      {fetched.classes && (
        <ClassSpreadSheet
          title={titles.bulkEditClasses}
          calling={calling}
          error={state.error}
          year={currentYear}
          classes={state.classes}
          save={bulkUpsertClassesFunc}
        />
      )}
    </div>
  );
};

export default BulkEditClasses;
